module.exports = __webpack_public_path__ + "static/media/mf_your_funds.26766a04.svg";